import { render, staticRenderFns } from "./AddType.vue?vue&type=template&id=364ada47&"
import script from "./AddType.vue?vue&type=script&lang=js&"
export * from "./AddType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports